<div class="col-md-12 lista-respostas">
    @for (resposta of respostas; track resposta) {
        <div class="card">
            <div class="card-header painelcabecalho"><b class="titulo-resposta">{{resposta.vendedor}}</b></div>
            @if (resposta.pecas.length > 0) {
                <div class="card-body lista-pecas">
                    <table style="width: 100%; table-layout: fixed;" class="tabela-statuscot table table-bordered table-hover">
                        <colgroup>
                            <col class="w_five" />
                            @if (this.userService.user().isAdmin) {
                                <col class="w_twenty_five" />
                            } @else{
                                <col class="w_thirty_five" />
                            }
                            <col class="w_ten" />
                            @if (this.userService.user().isAdmin) {
                                <col class="w_ten" />
                            }
                            <col class="w_ten" />
                            <col class="w_ten" />
                            <col class="w_ten" />
                            <col class="w_ten" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>{{ 'buyer.condicoes.resposta.pecas.quantidade' | translate}}</th>
                                <th>{{ 'buyer.condicoes.resposta.pecas.nome' | translate}}</th>
                                <th>{{ 'buyer.condicoes.resposta.pecas.tipo' | translate}}</th>
                                <th>{{ 'buyer.condicoes.resposta.pecas.usada' | translate}}</th>
                                @if (this.userService.user().isAdmin) {
                                    <th>{{ 'buyer.condicoes.resposta.pecas.valor-cia.label' | translate}}</th>
                                }
                                <th>{{ 'buyer.condicoes.resposta.pecas.valor' | translate}}</th>
                                <th>{{ 'buyer.condicoes.resposta.pecas.total' | translate}}</th>
                                <th class="text-center" tooltip="{{ 'buyer.condicoes.resposta.pecas.prazo.tooltip' | translate}}"><i class="fa icons fa-clock-o"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (peca of resposta.pecas; track peca) {
                                <tr (click)="selecionar(peca)" [ngClass]="{ 'selecionado': peca.isSelected }">
                                    <td class="text-center">{{peca.quantity}}</td>
                                    <td><div class="truncate">{{peca.partCodeName}}</div></td>
                                    <td>
                                        <div>{{peca.partTypeName}}
                                            <i tooltip="{{peca.brandAndType}}" class="fa fa-info-circle"></i>
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        @if (peca.isUsed) {
                                            <i class="fa fa-check"></i>
                                        }
                                    </td>
                                    @if (this.userService.user().isAdmin) {
                                        <td class="text-end colunaValor">{{peca.valorCia}}</td>
                                    }
                                    <td class="text-end colunaValor">{{ peca.price | currency: ' ' }} ({{ peca.discount }}%)</td>
                                    @if (peca.isBestPrice) {
                                        <td class="text-end text-success colunaValor text-nowrap" tooltip="{{ 'buyer.condicoes.resposta.pecas.melhor-preco' | translate}}">
                                            <b>
                                                {{peca.finalPrice | currency:' '}}
                                                <i class="fa icons fa-thumbs-o-up"></i>
                                            </b>
                                        </td>
                                    } @else {
                                        <td class="text-end colunaValor">
                                            <span>{{peca.finalPrice | currency:' '}}</span>
                                        </td>
                                    }
                                    <td class="text-center colunaPrazo" [ngClass]="peca.isBestDeliveryTime ? 'text-success text-bold' : ''">
                                        <span tooltip="{{ peca.tooltipPrazo | translate}}">
                                            {{peca.deliveryTimeFormatado}}
                                            @if (peca.isBestDeliveryTime && !peca.deliveryTimeIsPF && !peca.deliveryTimeIsBO) {
                                                <i class="fa icons fa-thumbs-o-up"></i>
                                            }
                                            @if (!peca.isBestDeliveryTime && !peca.deliveryTimeIsPF && !peca.deliveryTimeIsBO) {
                                                <i class="fa fa-home"></i>
                                            }
                                            @if (peca.deliveryTimeIsPF || peca.deliveryTimeIsBO) {
                                                <i class="fa fa-truck"></i>
                                            }
                                        </span>
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                    <div class="panel-footer">
                        <span class="section">
                            <span class="information-span">
                                <i class="fa fa-info-circle"></i>
                                <div>
                                    <span>
                                        <b>
                                            {{resposta.paymentType}}
                                            @if (resposta.paymentTypeTooltip) {
                                                <i class="fa fa-exclamation-circle text-warning" [tooltip]="resposta.paymentTypeTooltip"></i>
                                            }
                                        </b>
                                    </span>
                                </div>
                            </span>
                        </span>
                        <span class="section valores">
                            <ul class="price-informations">
                                <span class="base-infos">
                                    <li>
                                        <span>
                                            {{ 'buyer.condicoes.resposta.pecas.frete' | translate}}:
                                            @if (resposta.holdingShippingCost > 0) {
                                                <i class="fa fa-exclamation-circle text-warning"
                                                   [ngbTooltip]="shipping_information" tooltipClass="information-tooltip-window"
                                                   placement="left" [openDelay]="500"></i>
                                            }
                                        </span>
                                        <span>{{resposta.pecas[0]?.shippingCost > 0 ? (resposta.pecas[0]?.shippingCost | currency:' ') :(resposta.pecas[0]?.shippingText)}}</span>
                                        <ng-template #shipping_information>
                                            <div class="information-tooltip position">
                                                <div>
                                                    <i-feather name="truck"></i-feather>
                                                </div>
                                                <b>{{ 'buyer.cotacao.area-respostas.resposta.rodape.frete.tooltip.titulo' | translate }}</b>
                                                <ul>
                                                    <li>{{ 'buyer.cotacao.area-respostas.resposta.rodape.frete.tooltip.valor-regiao' | translate: { value: resposta.holdingShippingCost | currency:'R$'} }}</li>
                                                    <li>{{ 'buyer.cotacao.area-respostas.resposta.rodape.frete.tooltip.frete-gratis' | translate: { value: resposta.holdingMinValue | currency:'R$'} }}</li>
                                                </ul>
                                            </div>
                                        </ng-template>
                                    </li>
                                </span>
                            </ul>
                        </span>
                    </div>
                </div>
            }
        </div>
    }
</div>
